export { default as Card } from './Card'
export type { CardProps } from './Card'
